// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.version{color:var(--disabled-text-color);font-size:11px;padding:8px}`, "",{"version":3,"sources":["webpack://./src/components/version/version.css"],"names":[],"mappings":"AAAA,SACC,gCAAiC,CACjC,cAAe,CACf,WACD","sourcesContent":[".version {\n\tcolor: var(--disabled-text-color);\n\tfont-size: 11px;\n\tpadding: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
